import { Anchor, Stack, Table, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";
import { queryKeys, RestApi } from "../shared/RestApi";
import { NavBarContainer } from "./NavBarContainer";

export function MyLabelsPage() {
  const { t } = useTranslation();
  const { data: labels, isPending, isError } = useQuery({
    queryKey: queryKeys.labels,
    queryFn: () => RestApi.getLabels(),
  });

  return (
    <NavBarContainer title={t("myLabels.title")}>
      {isError && <Text c="red">{t("myLabels.loadError")}</Text>}
      {isPending && <Text>{t("myLabels.loading")}</Text>}
      {labels && labels.length === 0 && <Text>{t("myLabels.empty")}</Text>}
      {labels && labels.length > 0 && (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("myLabels.name")}</Table.Th>
              <Table.Th>{t("myLabels.date")}</Table.Th>
              <Table.Th />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {labels.map((l) => (
              <Table.Tr key={l.PointerToBlob}>
                <Table.Td>
                  <em>{l.FileName}</em>
                </Table.Td>
                <Table.Td>{new Date(l.CreatedDate).toLocaleString()}</Table.Td>
                <Table.Td>
                  <Anchor
                    component={Link}
                    to={`/mylabels/view?fileId=${encodeURIComponent(l.PointerToBlob)}`}
                  >
                    {t("myLabels.view")}
                  </Anchor>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </NavBarContainer>
  );
}

export function ViewLabelPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const fileId = params.get("fileId") || "";
  const { data: label, isError } = useQuery({
    queryKey: queryKeys.label(fileId),
    queryFn: () => RestApi.getLabel(fileId),
    enabled: !!fileId,
  });

  return (
    <NavBarContainer title={t("myLabels.title")}>
      <Stack gap="md">
        {isError && <Text c="red">{t("myLabels.loadError")}</Text>}
        {label && (
          <>
            <Text>
              <em>{label.FileName}</em>
            </Text>
            <Anchor
              href={`/api/file/download?fileId=${encodeURIComponent(label.PointerToBlob)}`}
            >
              {t("myLabels.download")}
            </Anchor>
          </>
        )}
        <Anchor component={Link} to="/mylabels">
          {t("myLabels.back")}
        </Anchor>
      </Stack>
    </NavBarContainer>
  );
}
